import * as React from "react";
import { useEffect } from "react";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Alert from '@mui/material/Alert';
import { AlertColor } from "@mui/material/Alert";

export type SanckBarProps = {
    show: boolean;
    message?: string;
    duration: number;
    color?: AlertColor;
    close?: boolean;
}

const SimpleSnackbar = ({show, message, duration, color, close }: SanckBarProps ) => {
    const [open, setOpen] = React.useState(false);

    const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    useEffect(() => {
        setOpen(show);
    }, [show]);

    return (
        <div>
            <Snackbar
                open={open}
                autoHideDuration={duration || 2000}
                onClose={handleClose}
                action={close ? action : false}
                sx={{width: "100%", mb: 3}} 
            >
                <Alert
                    onClose={close ? handleClose : null}
                    severity={color || "success"}
                    variant="filled"
                    style={{ width: "auto", minWidth: "auto", color: "#FFF", fontWeight: 800, padding: "initial", paddingInline: "8px" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default SimpleSnackbar;
